module.exports = __webpack_public_path__ + "img/SmartIBE-logo.9a011e91.png";